module.exports = __webpack_public_path__ + "static/media/github.0109fced.png";